import { Component, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from '../../alert-modal//alert-modal.component';

@Component({
  selector: 'app-source-document-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.metadata.title }}</h1>
    <div mat-dialog-content>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Metadata</mat-panel-title>
        </mat-expansion-panel-header>
        <table class="metadata-table">
          <thead>
            <tr>
              <th colspan="2">Document Metadata</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of metadataKeys">
              <td>
                <strong>{{ key | titlecase }}</strong>
              </td>
              <td>{{ data.metadata[key] }}</td>
            </tr>
          </tbody>
        </table>
      </mat-expansion-panel>
      <div *ngIf="summaryContent" class="parsed-content">
        <h2>Summary</h2>
        <pre>{{ summaryContent }}</pre>
      </div>
      <div *ngIf="mainContent" class="parsed-content">
        <h2>Content</h2>
        <pre>{{ mainContent }}</pre>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
  styles: [
    `
      pre {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
      h1,
      strong {
        font-size: 1.1rem;
      }
    `
  ]
})
export class SourceDocumentDialogNewComponent implements AfterViewInit {
  metadataKeys: string[];
  summaryContent: string | null = null;
  mainContent: string | null = null;

  constructor(
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    this.metadataKeys = Object.keys(this.data.metadata);

    // Parse the content
    this.parseContent(data.content);
  }

  // TODO check use of empty hook.
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngAfterViewInit() {}

  parseContent(content: string): void {
    const summaryMatch = content.match(/<summary>([\s\S]*?)<\/summary>/);
    const contentMatch = content.match(/<content>([\s\S]*?)<\/content>/);

    this.summaryContent = summaryMatch ? summaryMatch[1].trim() : null;
    this.mainContent = contentMatch ? contentMatch[1].trim() : null;

    // Check if there is no content to display
    if (!this.summaryContent && !this.mainContent) {
      this.dialog.open(AlertModalComponent, {
        data: {
          title: 'No Content Available',
          message: 'There is no content available for this source document.'
        }
      });
    }
  }
}
